import { render, staticRenderFns } from "./monthCumulative.vue?vue&type=template&id=632620f2&scoped=true"
import script from "./monthCumulative.vue?vue&type=script&lang=js"
export * from "./monthCumulative.vue?vue&type=script&lang=js"
import style0 from "./monthCumulative.vue?vue&type=style&index=0&id=632620f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632620f2",
  null
  
)

export default component.exports